import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, PageHeader, Button, Empty, Spin } from 'antd'
import useSWR from 'swr'
import { useSnapshot } from 'valtio'

import tableStore from '../../lib/store/subtitle_table'
import SubtitleService from '../../network/services/subtitle'
import { serialize } from '../../network/request'
import SubtitleTable from './SubtitleTable'

const SubtitlePage = () => {
  const navigate = useNavigate()
  const primaryAction = (
    <Button
      key="add"
      type="primary"
      onClick={() => {
        navigate('new')
      }}
    >
      Create Subtitle
    </Button>
  )

  return (
    <PageHeader title="All Subtitles" extra={[primaryAction]}>
      <Card>
        <SubtitleTableWrapper />
      </Card>
    </PageHeader>
  )
}

const SubtitleTableWrapper = () => {
  const { state } = useSnapshot(tableStore)

  // use this to preload
  const { data: response, error } = useSWR(
    serialize(SubtitleService.getAll, { page: 1, limit: state.pageSize, ...state.filters })
  )

  if (error) {
    console.log(error)
    return <Empty description={error?.message ?? 'Please try again later'} />
  }

  if (!response) {
    return <Spin />
  }

  const { total } = SubtitleService.toPaginate(response)

  return (
    <>
      <SubtitleTable total={total} />
      {/* preload next page */}
      {state.currentPage * state.pageSize < total && (
        <div style={{ display: 'none' }}>
          <SubtitleTable total={total} overridePage={state.currentPage + 1} />
        </div>
      )}
    </>
  )
}

export default SubtitlePage
